import {
  Box,
  Flex,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Stack,
  Text,
} from '@chakra-ui/react'
import { threadWeatherOrder } from '@rolebase/shared/model/threadWeather'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { HelpIcon, ThreadWeatherDoneIcon } from 'src/icons'
import { threadWeatherColors } from 'src/theme'
import { meetingThreadsSortModes } from './MeetingThreadsSortBar'
import { threadWeatherIcons } from './ThreadWeatherBadge'

// What the weathers and the sorts mean, one click away from the sort bar
// (Yohan, 17/09, #106): nothing shows until one asks.
export default function MeetingThreadsLegend() {
  const { t } = useTranslation()

  return (
    <Popover placement="bottom-start" isLazy>
      <PopoverTrigger>
        <IconButton
          size="sm"
          variant="ghost"
          aria-label={t('MeetingThreadsLegend.open')}
          icon={<HelpIcon size={20} />}
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="md" maxW="calc(100vw - 32px)">
          <PopoverArrow />
          <PopoverBody p={4}>
            <Text
              fontSize="xs"
              fontWeight="bold"
              textTransform="uppercase"
              color="gray.500"
              _dark={{ color: 'gray.400' }}
              mb={2}
            >
              {t('MeetingThreadsLegend.priorities')}
            </Text>
            <Stack spacing={2} mb={5}>
              {threadWeatherOrder.map((weather) => {
                const Icon = threadWeatherIcons[weather]
                return (
                  <Flex key={weather} align="start" gap={3}>
                    <Box
                      color={`${threadWeatherColors[weather]}.400`}
                      flexShrink={0}
                    >
                      <Icon />
                    </Box>
                    <Text fontSize="sm">
                      <Text as="span" fontWeight="bold">
                        {t(`ThreadWeather.${weather}`)}
                      </Text>
                      {t('MeetingThreadsLegend.separator')}
                      {t(`ThreadWeather.hint.${weather}`)}
                    </Text>
                  </Flex>
                )
              })}
              <Flex align="start" gap={3}>
                <Box flexShrink={0}>
                  <ThreadWeatherDoneIcon />
                </Box>
                <Text fontSize="sm">{t('ThreadWeather.reopen')}</Text>
              </Flex>
            </Stack>

            <Text
              fontSize="xs"
              fontWeight="bold"
              textTransform="uppercase"
              color="gray.500"
              _dark={{ color: 'gray.400' }}
              mb={2}
            >
              {t('MeetingThreadsLegend.sorts')}
            </Text>
            <Stack spacing={2}>
              {meetingThreadsSortModes.map((mode) => (
                <Text key={mode} fontSize="sm">
                  <Text as="span" fontWeight="bold">
                    {t(`MeetingThreadsSortBar.${mode}`)}
                  </Text>
                  {t('MeetingThreadsLegend.separator')}
                  {t(`MeetingThreadsLegend.sort.${mode}`)}
                </Text>
              ))}
            </Stack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  )
}
